import React, { useState, useEffect } from 'react';
import './Resenas.css';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { db } from '../firebaseConfig';
import { collection, getDocs, query, where } from 'firebase/firestore';
import ReviewFormModal from './ReviewFormModal'; // Import the new modal component

// Helper to render star ratings
const StarRating = ({ rating }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
      <span key={i} className={`star ${i <= rating ? 'filled' : ''}`}>
        ★
      </span>
    );
  }
  return <div className="star-rating">{stars}</div>;
};

function Resenas({ id }) {
  const [resenas, setResenas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false); // State for modal visibility

  const fetchResenas = async () => {
    try {
      const q = query(collection(db, 'reviews'), where('status', '==', 'approved'));
      const querySnapshot = await getDocs(q);
      const resenasData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setResenas(resenasData);
    } catch (err) {
      setError('Failed to load reviews.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResenas();
  }, []);

  const sliderSettings = {
    dots: true,
    infinite: resenas.length > 3,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  const handleReviewSubmit = () => {
    setIsReviewModalOpen(false);
    fetchResenas(); // Re-fetch reviews after submission
  };

  if (loading) return <section id={id} className="resenas-section"><p>Loading reviews...</p></section>;
  if (error) return <section id={id} className="resenas-section"><p>Error: {error}</p></section>;

  return (
    <section id={id} className="resenas-section">
      <h2 className="resenas-title">Lo que dicen nuestros clientes</h2>
      
      <div className="reviews-summary">
        <button className="leave-review-button" onClick={() => setIsReviewModalOpen(true)}>Deja tu reseña</button>
      </div>

      <div className="reviews-carousel-container">
        {resenas.length > 0 ? (
          <Slider {...sliderSettings}>
            {resenas.map(resena => (
              <div key={resena.id} className="review-card-wrapper">
                <div className="review-card">
                  <p className="review-text"><em>"{resena.comment}"</em></p>
                  <div className="review-footer">
                    <span className="reviewer-name">- {resena.author}</span>
                    <StarRating rating={resena.rating} />
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        ) : (
          <p>No hay reseñas disponibles en este momento.</p>
        )}
      </div>

      <ReviewFormModal 
        isOpen={isReviewModalOpen} 
        onClose={() => setIsReviewModalOpen(false)} 
        onSubmit={handleReviewSubmit} 
      />
    </section>
  );
}

export default Resenas;
